import VoyahTechnicalSpecsI18n from "../../Voyah/VoyahTechnicalSpecs/VoyahTechnicalSpecsI18n";
import tsImage from "../../../../assets/images/voyahdream/ts.png";

const VoyahDreamTechnicalSpecs = () => (
  <VoyahTechnicalSpecsI18n
    page="voyahdream"
    variant="dream"
    i18nPrefix="voyahDream"
    tsImage={tsImage}
    highlightKeys={["1", "2", "3", "4"]}
  />
);

export default VoyahDreamTechnicalSpecs;
